// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3ne3K","name":"ConsentHeader_name__1NIJO","birthday":"ConsentHeader_birthday__2Imy7","skeleton":"ConsentHeader_skeleton__2qDTH"};